// Central site configuration: categories, navigation and calculator metadata.

// Local banner images (downloaded into src/assets/banners).
import bannerPersonalFinance from "../assets/banners/personal-finance.jpg";
import bannerInvestment from "../assets/banners/investment.jpg";
import bannerEducation from "../assets/banners/education.jpg";
import bannerBanking from "../assets/banners/banking.jpg";
import bannerTax from "../assets/banners/tax.jpg";
import bannerTrending from "../assets/banners/trending.jpg";
import bannerBlog from "../assets/banners/blog.jpg";
import bannerAbout from "../assets/banners/about.jpg";
import bannerContact from "../assets/banners/contact.jpg";
import bannerPrivacy from "../assets/banners/privacy.jpg";

export const SITE = {
  name: "Finance Info",
  tagline: "Smart money decisions, simplified.",
};

// Categories drive both the navbar dropdowns and the category landing pages.
export const CATEGORIES = [
  {
    key: "personal-finance",
    label: "Personal Finance",
    emoji: "💰",
    blurb: "Build strong money habits budgeting, saving, credit and planning.",
    banner: bannerPersonalFinance,
  },
  {
    key: "investment",
    label: "Investment",
    emoji: "📈",
    blurb: "Grow your wealth with mutual funds, stocks, gold and more.",
    banner: bannerInvestment,
  },
  {
    key: "education",
    label: "Finance Education",
    emoji: "📚",
    blurb: "Learn the fundamentals of investing from the ground up.",
    banner: bannerEducation,
  },
  {
    key: "banking",
    label: "Banking",
    emoji: "🏦",
    blurb: "Accounts, cards and loans pick what's right for you.",
    banner: bannerBanking,
  },
  {
    key: "tax",
    label: "Tax (India)",
    emoji: "💵",
    blurb: "Save tax legally and file your returns with confidence.",
    banner: bannerTax,
  },
  {
    key: "trending",
    label: "Trending",
    emoji: "🔥",
    blurb: "What everyone is talking about in personal finance right now.",
    banner: bannerTrending,
  },
  {
    key: "blog",
    label: "Blog",
    emoji: "📰",
    blurb: "Fresh reads, case studies and answers to real money questions.",
    banner: bannerBlog,
  },
];

// Banners for non-category pages.
export const PAGE_BANNERS = {
  calculators: bannerPersonalFinance,
  about: bannerAbout,
  contact: bannerContact,
  privacy: bannerPrivacy,
};

// Builds a hero background: a dark green overlay (for readable white text)
// layered over the topic image, with a solid colour fallback if the image fails.
export const heroStyle = (img) => ({
  backgroundImage:
    `linear-gradient(#161515a6, #0e0e0eb3)` +
    (img ? `, url("${img}")` : ""),
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
});

export const CALCULATORS = [
  { slug: "sip", title: "SIP Calculator", emoji: "📊", color: "#2f6bff", desc: "Estimate the corpus your monthly SIP can build." },
  { slug: "emi", title: "EMI Calculator", emoji: "🏠", color: "#0aa172", desc: "Find your monthly loan instalment instantly." },
  { slug: "fd", title: "FD Calculator", emoji: "🏦", color: "#7c5cff", desc: "Project maturity value of a fixed deposit." },
  { slug: "rd", title: "RD Calculator", emoji: "💳", color: "#ff8a3d", desc: "See what your recurring deposit will grow to." },
  { slug: "compound-interest", title: "Compound Interest Calculator", emoji: "🔁", color: "#00b5c8", desc: "The 8th wonder of the world, quantified." },
  { slug: "retirement", title: "Retirement Calculator", emoji: "🌴", color: "#ff5d8f", desc: "How much you need to retire comfortably." },
  { slug: "loan-eligibility", title: "Loan Eligibility Calculator", emoji: "✅", color: "#4f46e5", desc: "Estimate the loan amount you may qualify for." },
  { slug: "gst", title: "GST Calculator", emoji: "🧾", color: "#e0a400", desc: "Add or remove GST from any amount." },
  { slug: "income-tax", title: "Income Tax Calculator", emoji: "📋", color: "#ef4444", desc: "Compare old vs new regime tax for FY 2025-26." },
  { slug: "inflation", title: "Inflation Calculator", emoji: "📉", color: "#0ea5e9", desc: "See the real future value of today's money." },
];

export const getCategory = (key) => CATEGORIES.find((c) => c.key === key);
